import React, { Suspense } from "react";
import { history } from "../../stores/_helpers/history";
import PropTypes from "prop-types";
import RouteEnum from "../../constants/RouteEnum";
import Toasts from "../components/common/toasts/Toasts";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { Spin } from "antd";
import Login from "views/pages/Login/Login";
import Extractpdf from "views/pages/Extractpdf/Extractpdf";
import InvoiceContent from "views/pages/Invoice/InvoiceContent";
export const RouteRegisterer = () => {
  return (
    <Spin spinning={false} tip="Loading..." className="spin-loading">
      <Router history={history}>
        <Suspense
          fallback={<Spin spinning tip="Loading..." className="spin-loading" />}
        >
          <Routes>
            <Route path="/" element={<Navigate to="/login" />} />
            <Route exact path={RouteEnum.Login} element={<Login />} />
            <Route exact path={RouteEnum.Extractpdf} element={<Extractpdf />} />
            <Route
              exact
              path={RouteEnum.Invoice}
              element={<InvoiceContent />}
            />
          </Routes>
        </Suspense>
        <Toasts />
      </Router>
    </Spin>
  );
};

RouteRegisterer.propTypes = {
  isRequesting: PropTypes.bool,
};

export { RouteRegisterer as UnConnectedRoutes };
export default RouteRegisterer;
